import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initAnalytics } from './analytics.js';
import { captureAttribution } from './attribution.js';

// Order matters: capture the campaign context from the URL before anything
// navigates or rewrites the query string, then boot the pixels.
captureAttribution();
initAnalytics();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
